export default __webpack_public_path__ + "static/media/icon-rest-day.833d79d4.svg";